var _defs, _rect, _rect2, _polygon, _polygon2, _polygon3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _rect3, _line, _text, _circle, _line2, _text2, _circle2, _text3, _circle3, _line3, _line4, _text4, _circle4, _line5, _rect4, _rect5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBvm2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 418.96 452.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d5ddeb;}.cls-2,.cls-4{fill:#fff;}.cls-2{opacity:0.5;}.cls-3,.cls-8{fill:#812990;}.cls-5{fill:#6b7b84;}.cls-6{fill:#231f20;}.cls-7,.cls-9{fill:none;stroke:#6b7b84;stroke-miterlimit:10;stroke-width:0.5px;}.cls-8{font-size:8px;font-family:ProximaNova-Regular, Proxima Nova;}.cls-9{stroke-dasharray:2 2;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 50.2,
    y: 33.62,
    width: 368.5,
    height: 368.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 197.61,
    y: 236.3,
    width: 184.25,
    height: 128.98
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "418.83 401.99 68.76 401.99 179.31 217.74 418.83 217.74 418.83 401.99"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "289.86 33.48 179.31 217.74 68.76 33.48 289.86 33.48"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "50.33 33.48 68.76 33.48 179.31 217.74 68.76 401.99 50.33 401.99 50.33 33.48"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M71.88,234.73v.72H68.76v-4.07h3v.72h-2.2v1H71.4v.69H69.56v.91Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M76.25,231.1v4.35h-.81v-.19a1.84,1.84,0,0,1-.91.24,1.62,1.62,0,0,1,0-3.24,2,2,0,0,1,.91.23V231.1Zm-.81,3.4v-1.26a1.19,1.19,0,0,0-.77-.26.89.89,0,0,0-.93.9.87.87,0,0,0,.93.89A1.16,1.16,0,0,0,75.44,234.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M80.59,232.32v3.13h-.81v-.21a1.49,1.49,0,0,1-.85.25c-.92,0-1.34-.42-1.34-1.44v-1.73h.8v1.73c0,.49.24.72.68.72a1,1,0,0,0,.71-.25v-2.2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M84.74,234.86a1.5,1.5,0,0,1-1.21.63,1.62,1.62,0,1,1,0-3.23,1.51,1.51,0,0,1,1.22.62l-.52.48a.86.86,0,0,0-.7-.38.9.9,0,1,0,0,1.79.86.86,0,0,0,.7-.38Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M89.09,232.32v3.13h-.8v-.23a1.66,1.66,0,0,1-.92.27,1.62,1.62,0,0,1,0-3.24,1.89,1.89,0,0,1,.92.26v-.19Zm-.8.93a1.18,1.18,0,0,0-.77-.27.9.9,0,1,0,0,1.79,1.23,1.23,0,0,0,.77-.26Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M91.45,233v1.11c0,.56.09.72.5.72a3.7,3.7,0,0,0,.37,0v.6a2.15,2.15,0,0,1-.73.11.9.9,0,0,1-1-1V233H90.2v-.66h.44V231.1h.81v1.22h.88V233Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M93.46,231.51a.46.46,0,1,1,.46.47A.46.46,0,0,1,93.46,231.51Zm.06.81h.8v3.13h-.8Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M99,233.88a1.72,1.72,0,1,1-1.71-1.62A1.66,1.66,0,0,1,99,233.88Zm-.79,0a.92.92,0,1,0-.92.89A.91.91,0,0,0,98.2,233.88Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M103.21,233.7v1.75h-.81V233.7c0-.48-.23-.72-.68-.72a1,1,0,0,0-.69.25v2.22h-.8v-3.13h.8v.19a1.46,1.46,0,0,1,.84-.25C102.78,232.26,103.21,232.68,103.21,233.7Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M110.56,233.64a7.37,7.37,0,0,1-.61.93l.49.48-.49.44-.45-.44a1.76,1.76,0,0,1-1.08.44c-.93,0-1.53-.44-1.53-1.18a1.23,1.23,0,0,1,.85-1.09,1.08,1.08,0,0,1-.36-.78,1.16,1.16,0,0,1,2.31-.09,1.25,1.25,0,0,1-.88,1.11l.7.67a6.27,6.27,0,0,0,.48-.67Zm-1.48,1-.91-.89c-.33.13-.48.34-.48.57s.28.57.77.57A1,1,0,0,0,109.08,234.6Zm-1-2.14a.81.81,0,0,0,.36.58c.26-.08.61-.26.61-.59a.49.49,0,0,0-.49-.53A.51.51,0,0,0,108.05,232.46Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M117.25,231.38h.9l-1.9,4.07h-.38l-1.9-4.07h.9l1.19,2.65Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M119.16,231.51a.47.47,0,0,1,.46-.47.47.47,0,0,1,0,.94A.47.47,0,0,1,119.16,231.51Zm.06.81H120v3.13h-.81Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M121.56,234.6a2.43,2.43,0,0,0,1.07.25c.37,0,.52-.14.52-.3s-.18-.26-.67-.36c-.67-.15-1.16-.37-1.16-1s.46-1,1.19-1a3.11,3.11,0,0,1,1.22.25l-.26.59a2.86,2.86,0,0,0-1-.2c-.3,0-.46.11-.46.28s.19.25.69.35c.73.15,1.15.41,1.15,1s-.45,1-1.26,1a2.68,2.68,0,0,1-1.35-.3Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M128.24,232.32v3.13h-.8v-.23a1.66,1.66,0,0,1-.92.27,1.62,1.62,0,0,1,0-3.24,1.93,1.93,0,0,1,.92.26v-.19Zm-.8.93a1.21,1.21,0,0,0-.78-.27.9.9,0,1,0,0,1.79,1.24,1.24,0,0,0,.78-.26Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M135.26,234.25c0,.79-.63,1.25-1.57,1.25a3.06,3.06,0,0,1-1.69-.39l.3-.64a2.86,2.86,0,0,0,1.42.31c.44,0,.71-.16.71-.46s-.27-.4-.87-.53c-.84-.19-1.51-.43-1.51-1.23s.57-1.22,1.5-1.22a4,4,0,0,1,1.56.32l-.34.66a3.54,3.54,0,0,0-1.24-.27c-.41,0-.65.18-.65.44s.29.41.91.55C134.66,233.23,135.26,233.51,135.26,234.25Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M137.17,234.11a.86.86,0,0,0,.89.7,1,1,0,0,0,.81-.39l.51.43a1.73,1.73,0,0,1-1.41.64,1.62,1.62,0,0,1,0-3.23,1.5,1.5,0,0,1,1.52,1.67v.18Zm0-.51h1.55a.69.69,0,0,0-.75-.7A.83.83,0,0,0,137.17,233.6Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M141.53,232.75a1.17,1.17,0,0,1,1-.49.69.69,0,0,1,.2,0v.87a2.65,2.65,0,0,0-.39,0,.75.75,0,0,0-.79.82v1.51h-.81v-3.13h.81Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M147,232.32l-1.5,3.13h-.39l-1.5-3.13h.84l.86,1.77.84-1.77Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M148.07,231.51a.47.47,0,0,1,.46-.47.47.47,0,0,1,0,.94A.47.47,0,0,1,148.07,231.51Zm.06.81h.81v3.13h-.81Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M153.11,234.86a1.48,1.48,0,0,1-1.21.63,1.62,1.62,0,1,1,0-3.23,1.51,1.51,0,0,1,1.22.62l-.52.48a.84.84,0,0,0-.7-.38.9.9,0,1,0,0,1.79.84.84,0,0,0,.7-.38Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M154.89,234.11a.86.86,0,0,0,.89.7,1,1,0,0,0,.81-.39l.51.43a1.71,1.71,0,0,1-1.41.64,1.62,1.62,0,0,1,0-3.23,1.5,1.5,0,0,1,1.52,1.67v.18Zm0-.51h1.56a.69.69,0,0,0-.76-.7A.83.83,0,0,0,154.89,233.6Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M158.57,234.6a2.43,2.43,0,0,0,1.07.25c.37,0,.51-.14.51-.3s-.17-.26-.66-.36c-.67-.15-1.17-.37-1.17-1s.47-1,1.2-1a3.11,3.11,0,0,1,1.22.25l-.26.59a2.86,2.86,0,0,0-1-.2c-.3,0-.46.11-.46.28s.19.25.69.35c.73.15,1.15.41,1.15,1s-.45,1-1.26,1a2.68,2.68,0,0,1-1.35-.3Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M158.06,200.42h-.77v2.18h-.45v-2.18h-.78V200h2Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M160.88,200v2.63h-.45v-1.86l-.87,1.34-.86-1.34v1.86h-.45V200h.49l.82,1.28.83-1.28Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M88.7,206.8v.85a5.66,5.66,0,0,0-1.5-.81,5.52,5.52,0,0,0-1.94-.32A5.76,5.76,0,0,0,83,207a5.71,5.71,0,0,0-1.8,1.19,5.65,5.65,0,0,0,0,7.91,5.71,5.71,0,0,0,1.8,1.19,5.76,5.76,0,0,0,2.26.44h.23a6.16,6.16,0,0,0,2.28-.43v-3a3.21,3.21,0,0,1-1.05.66,3.3,3.3,0,0,1-1.22.22,3,3,0,0,1-.52,0h0a2.92,2.92,0,0,1-.72-.18,3,3,0,0,1-1-.66,2.88,2.88,0,0,1-.94-2.14,2.91,2.91,0,0,1,.94-2.17,3.1,3.1,0,0,1,1-.65,3.22,3.22,0,0,1,1.24-.24,3.18,3.18,0,0,1,2.27.89,2.91,2.91,0,0,1,.94,2.17v5.57h2.67V206.8Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M77.37,217.69,71.43,212v5.73H68.76V202.6h2.67v5.71l5.94-5.68h3.79l-7.83,7.5,7.83,7.56Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M98.33,206.52a4.78,4.78,0,0,1,2,.4,4.62,4.62,0,0,1,1.53,1.08,4.88,4.88,0,0,1,1,1.59,5.48,5.48,0,0,1,.34,1.95v6.15H100.5v-6.15a2.24,2.24,0,0,0-.78-1.75,2.68,2.68,0,0,0-3.68,0,2.3,2.3,0,0,0-.76,1.75v6.15H92.6V206.82h2.68v.8a5.21,5.21,0,0,1,1.36-.79A4.54,4.54,0,0,1,98.33,206.52Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M134.62,206.82a4.76,4.76,0,0,1,1.79-.32V209a3.18,3.18,0,0,0-2.27.89,3,3,0,0,0-.94,2.16v5.6h-2.68V206.8h2.68v.82A5.94,5.94,0,0,1,134.62,206.82Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M142.47,206.52a6.07,6.07,0,0,1,4.17,1.63,5.88,5.88,0,0,1,1.26,1.78,5.37,5.37,0,0,1,.46,2.19,5.3,5.3,0,0,1-.46,2.16,5.88,5.88,0,0,1-1.26,1.78,6.07,6.07,0,0,1-4.17,1.63,6.07,6.07,0,0,1-4.17-1.63,5.55,5.55,0,0,1-1.26-1.78,5.14,5.14,0,0,1-.46-2.16,5.21,5.21,0,0,1,.46-2.19,5.55,5.55,0,0,1,1.26-1.78,6.07,6.07,0,0,1,4.17-1.63Zm0,2.54a3.22,3.22,0,0,0-2.28.89,2.91,2.91,0,0,0-.93,2.17,2.87,2.87,0,0,0,.93,2.14,3,3,0,0,0,1,.66,3.45,3.45,0,0,0,1.24.22,3.3,3.3,0,0,0,1.22-.22,3.21,3.21,0,0,0,1.05-.66,2.85,2.85,0,0,0,.94-2.14,2.88,2.88,0,0,0-.94-2.17A3.28,3.28,0,0,0,142.47,209.06Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M155,206.52a6.07,6.07,0,0,1,4.17,1.63,5.55,5.55,0,0,1,1.26,1.78,5.21,5.21,0,0,1,.46,2.19,5.14,5.14,0,0,1-.46,2.16,5.55,5.55,0,0,1-1.26,1.78,6.18,6.18,0,0,1-6.47,1.19,6.15,6.15,0,0,1-1.87-1.19,5.88,5.88,0,0,1-1.26-1.78,5.3,5.3,0,0,1-.46-2.16,5.37,5.37,0,0,1,.46-2.19,5.88,5.88,0,0,1,1.26-1.78,6.15,6.15,0,0,1,1.87-1.19A6.08,6.08,0,0,1,155,206.52Zm0,2.54a3.18,3.18,0,0,0-2.27.89,2.88,2.88,0,0,0-.94,2.17,2.85,2.85,0,0,0,.94,2.14,2.94,2.94,0,0,0,1,.66,3.49,3.49,0,0,0,1.24.22,3.39,3.39,0,0,0,1.23-.22,3.21,3.21,0,0,0,1.05-.66,2.88,2.88,0,0,0,.94-2.14,2.91,2.91,0,0,0-.94-2.17A3.31,3.31,0,0,0,155,209.06Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M126.37,206.8v.85a5.82,5.82,0,0,0-1.5-.81,5.52,5.52,0,0,0-1.94-.32,5.76,5.76,0,0,0-2.26.44,5.71,5.71,0,0,0-1.8,1.19,5.48,5.48,0,0,0-1.18,1.78,5.7,5.7,0,0,0-.43,2.19,5.62,5.62,0,0,0,.43,2.16,5.48,5.48,0,0,0,1.18,1.78,5.71,5.71,0,0,0,1.8,1.19,5.76,5.76,0,0,0,2.26.44h.22a6.18,6.18,0,0,0,2.29-.43v-3a3.21,3.21,0,0,1-1.05.66,3.39,3.39,0,0,1-1.23.22,3,3,0,0,1-.52,0h0a3,3,0,0,1-.71-.18,2.89,2.89,0,0,1-1-.66,2.85,2.85,0,0,1-.94-2.14,2.88,2.88,0,0,1,.94-2.17,3,3,0,0,1,1-.65,3.33,3.33,0,0,1,3.51.65,2.91,2.91,0,0,1,.94,2.17v5.57H129V206.8Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M113.39,206.8v.85a5.75,5.75,0,0,0-1.49-.81,4.92,4.92,0,0,0-1-.24,6,6,0,0,0-1.15-.1,5.53,5.53,0,0,0-2.22.44,5.08,5.08,0,0,0-1.74,1.19,5.4,5.4,0,0,0-1.13,1.78,5.86,5.86,0,0,0-.4,2.18h0v0a5.5,5.5,0,0,0,1.61,3.94,5.55,5.55,0,0,0,1.79,1.19,5.81,5.81,0,0,0,2.27.44h.39a6.15,6.15,0,0,0,2.11-.42v-3a3.28,3.28,0,0,1-1,.66,3.39,3.39,0,0,1-1.23.22,3,3,0,0,1-.52,0h0a2.92,2.92,0,0,1-.72-.18,3.07,3.07,0,0,1-1-.66,2.88,2.88,0,0,1-.93-2.16,2.8,2.8,0,0,1,.22-1.12.36.36,0,0,1,0-.09,3.13,3.13,0,0,1,.67-.94,3.2,3.2,0,0,1,1-.65,3.3,3.3,0,0,1,1.24-.24,3.18,3.18,0,0,1,2.27.89,3,3,0,0,1,.68.94.36.36,0,0,1,0,.09,2.86,2.86,0,0,1,.22,1.14v4.23a2.82,2.82,0,0,1-.94,2.14,3.07,3.07,0,0,1-2.27.91,3.12,3.12,0,0,1-1.61-.42l-1.94,1.82a6.15,6.15,0,0,0,1.65.85,6.13,6.13,0,0,0,4.2-.15,6.2,6.2,0,0,0,1.87-1.21,5.45,5.45,0,0,0,1.26-1.78,5.23,5.23,0,0,0,.46-2.16V206.8Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M71.87,226.9v.71H68.76v-4.05h3v.71H69.56v1h1.83V226H69.56v.91Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M77,223.22v4.34h-.8v-.19a1.87,1.87,0,0,1-.91.24,1.62,1.62,0,0,1,0-3.23,2,2,0,0,1,.91.23v-1.39Zm-.8,3.39v-1.25a1.19,1.19,0,0,0-.77-.26.89.89,0,0,0-.93.89.88.88,0,0,0,.93.89A1.16,1.16,0,0,0,76.2,226.61Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M82.1,224.44v3.12h-.79v-.2a1.52,1.52,0,0,1-.85.25c-.92,0-1.34-.43-1.34-1.44v-1.73h.8v1.73c0,.48.24.72.68.72a1.06,1.06,0,0,0,.71-.25v-2.2Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M87,227a1.51,1.51,0,0,1-1.21.63,1.62,1.62,0,1,1,0-3.23A1.53,1.53,0,0,1,87,225l-.52.48a.85.85,0,0,0-.7-.38.9.9,0,1,0,0,1.79.85.85,0,0,0,.7-.38Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M92.15,224.44v3.12h-.8v-.23a1.58,1.58,0,0,1-.91.28,1.62,1.62,0,0,1,0-3.23,1.81,1.81,0,0,1,.91.26v-.2Zm-.8.93a1.24,1.24,0,0,0-.77-.27.9.9,0,1,0,0,1.79,1.23,1.23,0,0,0,.77-.26Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M95.28,225.1v1.11c0,.55.09.71.5.71l.36,0v.59a1.67,1.67,0,0,1-.72.12.9.9,0,0,1-.94-1V225.1H94v-.66h.45v-1.21h.8v1.21h.88v.66Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M98.06,223.68a.47.47,0,0,1,.46-.47.47.47,0,0,1,0,.94A.47.47,0,0,1,98.06,223.68Zm.07.81h.8v3.12h-.8Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M104.36,226a1.71,1.71,0,1,1-1.7-1.62A1.66,1.66,0,0,1,104.36,226Zm-.78,0a.92.92,0,1,0-.92.89A.91.91,0,0,0,103.58,226Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M109.34,225.87v1.74h-.8v-1.74c0-.49-.23-.72-.67-.72a1,1,0,0,0-.69.25v2.21h-.8v-3.12h.8v.19a1.43,1.43,0,0,1,.83-.25C108.92,224.43,109.34,224.86,109.34,225.87Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M115.62,224.27v1.44h1.93v.71h-1.93v1.19h-.8v-4.05h3.05v.71Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M123,226a1.71,1.71,0,1,1-1.71-1.62A1.66,1.66,0,0,1,123,226Zm-.79,0a.9.9,0,0,0-.92-.9.9.9,0,1,0,0,1.79A.9.9,0,0,0,122.24,226Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M128,224.44v3.12h-.8v-.2a1.49,1.49,0,0,1-.85.25c-.91,0-1.33-.43-1.33-1.44v-1.73h.8v1.73c0,.48.23.72.68.72a1,1,0,0,0,.7-.25v-2.2Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M133.12,225.87v1.74h-.8v-1.74c0-.49-.23-.72-.68-.72a1,1,0,0,0-.69.25v2.21h-.8v-3.12h.8v.19a1.46,1.46,0,0,1,.84-.25C132.7,224.43,133.12,224.86,133.12,225.87Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M138.4,223.22v4.34h-.81v-.19a1.81,1.81,0,0,1-.91.24,1.62,1.62,0,0,1,0-3.23,1.92,1.92,0,0,1,.91.23v-1.39Zm-.81,3.39v-1.25a1.18,1.18,0,0,0-.76-.26.88.88,0,0,0-.93.89.87.87,0,0,0,.93.89A1.14,1.14,0,0,0,137.59,226.61Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M143.69,224.44v3.12h-.8v-.23a1.59,1.59,0,0,1-.92.28,1.62,1.62,0,0,1,0-3.23,1.82,1.82,0,0,1,.92.26v-.2Zm-.8.93a1.24,1.24,0,0,0-.77-.27.9.9,0,1,0,0,1.79,1.23,1.23,0,0,0,.77-.26Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M146.82,225.1v1.11c0,.55.09.71.49.71l.37,0v.59a1.67,1.67,0,0,1-.72.12.9.9,0,0,1-.94-1V225.1h-.45v-.66H146v-1.21h.8v1.21h.87v.66Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M149.6,223.68a.47.47,0,0,1,.46-.47.47.47,0,0,1,0,.94A.47.47,0,0,1,149.6,223.68Zm.07.81h.79v3.12h-.79Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M155.9,226a1.71,1.71,0,1,1-1.7-1.62A1.66,1.66,0,0,1,155.9,226Zm-.78,0a.92.92,0,1,0-.92.89A.91.91,0,0,0,155.12,226Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M160.88,225.87v1.74h-.8v-1.74c0-.49-.23-.72-.68-.72a1,1,0,0,0-.69.25v2.21h-.79v-3.12h.79v.19a1.46,1.46,0,0,1,.84-.25C160.46,224.43,160.88,224.86,160.88,225.87Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 197.73,
    y: 236.16,
    width: 184.25,
    height: 128.98
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 11.73,
    y1: 219.29,
    x2: 68.49,
    y2: 219.29
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(4.55 222.07)"
  }, "1")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 5.92,
    cy: 219.29,
    r: 5.67
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 363.59,
    y1: 440.79,
    x2: 363.59,
    y2: 336.55
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(361.35 449.17)"
  }, "4")), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 363.59,
    cy: 446.46,
    r: 5.67
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(178.37 8.63)"
  }, "2")), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 180.74,
    cy: 5.92,
    r: 5.67
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 179.14,
    y1: 112.93,
    x2: 179.14,
    y2: 11.26
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 182.31,
    y1: 11.26,
    x2: 182.31,
    y2: 277.82
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(341.94 8.63)"
  }, "3")), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 344.18,
    cy: 5.92,
    r: 5.67
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 344.17,
    y1: 112.93,
    x2: 344.17,
    y2: 11.26
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 68.63,
    y: 199.45,
    width: 92.13,
    height: 36.85
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 50.2,
    y: 33.62,
    width: 368.5,
    height: 368.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBvm2);
export default __webpack_public_path__ + "static/media/bvm2.87ab994be7a37c5eacb3a2b12809867a.svg";
export { ForwardRef as ReactComponent };